import React from 'react';
import { useTranslations } from 'next-intl';

export function AddedToCart({ productName }: { productName: string }) {
  const t = useTranslations('AddedToCart');

  return (
    <div className=" mt-4">
      <div className="rounded-sm border border-primary-100 bg-primary-5 p-2 text-center font-medium ">
        {productName} {t('successfully added to your cart!')}
      </div>
    </div>
  );
}
